import { DocPageComment } from "../../types"

interface CommentsIndexProps {
    comments: DocPageComment[],
    action: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export default function DocCommentsIndex({ comments, action }: Readonly<CommentsIndexProps>) {
    return <ul>
        {comments.map(c => <li key={c.id}>
            <a onClick={action} href={`#${c.id}`}>{c.user} (#{c.id})</a>
            {c.comments.length > 0 && <DocCommentsIndex action={action} comments={c.comments} />}
        </li>)}
    </ul>
}